import classNames from "classnames";
import AutoSelect from "PFComponents/select/autoselect";
import Select from "PFComponents/select/select";
import { SkillsDeltaData } from "PFCore/hooks/queries/insights/use_skills_delta_query";
import React, { Dispatch, SetStateAction, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useIsSkillFilterActive } from "../../../hooks/use_is_skill_filter_active";
import { SelectorOption } from "../../../hooks/use_supply_demand_section";
import css from "./skills_delta.module.scss";

export type SortByItem = "active" | "inactive";

type SortByOption = {
  item: SortByItem;
  displayElement: JSX.Element;
};

type Option = {
  id: number | string;
  item: number | string;
  displayElement: number | JSX.Element;
};

interface SkillsDeltaSelectorsProps {
  graphData: SkillsDeltaData | undefined;
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<SortByItem>>;
  selectedSkill: SelectorOption[];
  setSelectedSkill: Dispatch<SetStateAction<SelectorOption[]>>;
  loading: boolean;
  nOptions: Option[];
  selectedN: number;
  setSelectedN: Dispatch<SetStateAction<number>>;
  timeOptions: Option[];
  selectedTime: number;
  setSelectedTime: Dispatch<SetStateAction<number>>;
}

const SkillsDeltaSelectors = ({
  graphData,
  sortBy,
  setSortBy,
  selectedSkill,
  setSelectedSkill,
  loading,
  nOptions,
  selectedN,
  setSelectedN,
  timeOptions,
  selectedTime,
  setSelectedTime
}: SkillsDeltaSelectorsProps): JSX.Element => {
  const isSkillFilterActive = useIsSkillFilterActive();

  const { t } = useTranslation("insights");

  const sortByOptions = useMemo<SortByOption[]>(
    () => [
      {
        item: "active",
        displayElement: <div>{t("filters.sortByActive")}</div>
      },
      {
        item: "inactive",
        displayElement: <div>{t("filters.sortByInactive")}</div>
      }
    ],
    []
  );

  return (
    <div className={css.skillsDeltaFilters}>
      <div className={css.skillsDeltaFiltersItem}>
        <Select
          /* @ts-ignore */
          label={t("filters.sortByActiveInactive")}
          options={sortByOptions}
          controlledValue
          value={sortBy === "active" ? t("filters.sortByActive") : t("filters.sortByInactive")}
          handleClose={() => {}}
          handleChange={setSortBy}
          rootClassName={css.select}
        />
      </div>
      {!isSkillFilterActive && (
        <AutoSelect
          multi={false}
          closeOnChange={true}
          values={selectedSkill}
          letClear
          query={(term) =>
            Promise.resolve(
              graphData?.dropdown
                ?.map((item) => ({ text: item.label, value: item.value }))
                ?.filter((item) => item.value.toLowerCase().includes(term.toLowerCase()))
            )
          }
          handleChange={setSelectedSkill}
          disabled={loading}
          allowSameValueInOptions
          rootClassName={classNames(css.select, css.skillsDeltaFiltersItem)}
          label={t("selectedSkill")}
        />
      )}
      <Select
        /* @ts-ignore */
        label={t("numberOfSkills")}
        options={nOptions}
        controlledValue
        value={selectedN}
        handleClose={() => {}}
        handleChange={setSelectedN}
        rootClassName={classNames(css.select, css.skillsDeltaFiltersItem)}
      />
      <Select
        /* @ts-ignore */
        label={t("pastNumberOfMonths")}
        options={timeOptions}
        controlledValue
        value={selectedTime}
        handleClose={() => {}}
        handleChange={setSelectedTime}
        rootClassName={classNames(css.select, css.skillsDeltaFiltersItem)}
      />
    </div>
  );
};

export default SkillsDeltaSelectors;
